import { Box, Center, Flex, Spinner, type SpinnerProps } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';
import { Suspense } from 'react';

export interface LazyWrapperProps extends PropsWithChildren {
  spinProps?: SpinnerProps;
  extraLoading?: boolean;
}

export function LazyWrapper({ children, extraLoading = false }: LazyWrapperProps) {
  return (
    <Suspense
      fallback={
        <Flex
          className="LazyWrapper"
          justifyContent="center"
          alignItems="center"
          h="full"
          w="full"
        >
          {extraLoading ? (
            <Box>
              <Center>
                <Spinner size="sm" />
              </Center>
              <Box>Loading...</Box>
            </Box>
          ) : (
            <Spinner size="sm" />
          )}
        </Flex>
      }
    >
      {children}
    </Suspense>
  );
}
